import { configureStore } from '@reduxjs/toolkit'
import authReducer from './Reducers/Auth';
import entriesReducer from './Reducers/Entries';

export default configureStore({
    reducer: { auth: authReducer, entries: entriesReducer },
})